import { Table } from 'dexie';
import { DownloadRequest } from '../types/downloads';
import { BaseModel } from './base-model';

const SCHEMA = {
  requests:
    'id, url, downloadId, timestamp, mediaType, modelDownloadName, modelDownloadRequestId',
};
const SCHEMA_VERSION = 2;
export class DownloadRequestModel extends BaseModel {
  downloads!: Table<DownloadRequest>;

  constructor() {
    super('downloads');
    this.version(SCHEMA_VERSION).stores(SCHEMA);
    this.downloads = this.table('requests');
  }
  async addDownloadRequest(request: DownloadRequest) {
    return this.downloads.put(request);
  }

  async addBulkDownloadRequest(requests: DownloadRequest[]) {
    return this.downloads.bulkPut(requests);
  }

  async getDownloadRequest(id: number) {
    return this.downloads?.get(id) || null;
  }
  async getDownloadRequests() {
    return this.downloads?.toArray() || [];
  }
  async removeDownloadRequest(id: number) {
    return this.downloads?.delete(id);
  }
  async clearDownloadRequests() {
    return this.downloads?.clear();
  }
  async getDownloadRequestByTrainingURL(trainingURL: string) {
    return this.downloads?.where('url').equals(trainingURL).first() || null;
  }
  async getDownloadRequestByLpAssetURLAndId(lpAssetURL: string, id: number) {
    return (
      (
        (await this.downloads?.where('url').equals(lpAssetURL).toArray()) || []
      ).find((record) => record.modelDownloadRequestId === id) || null
    );
  }
  async getDownloadRequestByModelName(name: string) {
    return await this.downloads
      ?.where('modelDownloadName')
      .equals(name)
      .toArray();
  }
  async getDownloadRequestByModelDownloadRequestId(id: number) {
    return await this.downloads
      ?.where('modelDownloadRequestId')
      .equals(id)
      .toArray();
  }

  async deleteDownloadRequestByModelDownloadRequestId(id: number) {
    try {
      // Find the record(s) with the specified modelDownloadRequestId
      const recordsToDelete = await this.downloads
        ?.where('modelDownloadRequestId')
        .equals(id)
        .toArray();

      if (recordsToDelete && recordsToDelete.length > 0) {
        for (const record of recordsToDelete) {
          await this.downloads?.delete(record.id);
        }
      }
    } catch (error) {
      console.error('Error deleting record:', error);
    }
  }
}

export const downloadRequestModel = new DownloadRequestModel();
